module.exports = __webpack_public_path__ + "img/1485884157.b9109cf6.jpg";